import {FieldTypeEnum} from './field-type.enum';
import {ControlUpdater} from './control-updater.type';

export type FieldTypeToControlUpdater = Map<FieldTypeEnum, ControlUpdater>;

